import { getCookie } from 'libs/utils/cookies';
import { AuthView, stateName } from './constants';

const localState = state => state[stateName];

export const getReferrerId = state => localState(state).referrerId;
export const getIsRealNameRequired = state => localState(state).isRealNameRequired;
export const getIsRandomUserSignupEnabled = state => localState(state).isRandomUserSignupEnabled;
export const getNewsletterSubscription = state => localState(state).newsletterSubscription;
export const getIsAuthModalOpen = state => localState(state).isAuthModalOpen || false;
export const getAuthView = state => localState(state).authView || (getCookie('last_user_id') ? AuthView.SelectTypeLogin : AuthView.SelectTypeRegister);
export const getIsSelectTypeLogin = state => getAuthView(state) === AuthView.SelectTypeLogin;
export const getIsBusinessRegistrationLinkVisible = state => localState(state).isBusinessRegistrationLinkVisible;
export const getExternalRegisterData = state => localState(state).externalRegisterData;
export const getIsFacebookIsInitialized = state => localState(state).isFacebookIsInitialized || false;
export const getIsBusinessAuth = state => localState(state).isBusiness || false;